import { gql } from '@apollo/client';

export const WIFI_INFO_FIELDS = gql`
  fragment WifiInfoFields on WifiInfo {
    _id
    ssid
    connection
    security
    psk
    authentication
    username
    certificateInfo
    certificateFilename
    caCertificateInfo
    caCertificateFilename
    privateKeyInfo
    privateKeyFilename
    certificateFormat
    hidden
    encrypted
    createdAt
  }
`;

export const WIFI_INFOS_QUERY = gql`
  query wifiInfos($teamId: String, $filter: QueryWifiInfoInput) {
    wifiInfos(teamId: $teamId, filter: $filter) {
      ...WifiInfoFields
    }
  }
  ${WIFI_INFO_FIELDS}
`;

export const SAVE_WIFI_INFO = gql`
  mutation saveWifiInfo($teamId: String, $payload: WifiInfoInput!) {
    saveWifiInfo(teamId: $teamId, payload: $payload) {
      ...WifiInfoFields
    }
  }
  ${WIFI_INFO_FIELDS}
`;

export const DELETE_WIFI_INFO = gql`
  mutation deleteWifiInfo($_id: String!) {
    deleteWifiInfo(_id: $_id)
  }
`;
